export const ALLOW_EXTRA_REGISTRANTS = 'ALLOW_EXTRA_REGISTRANTS';
export const ADD_EXTRA_REGISTRANTS = 'ADD_EXTRA_REGISTRANTS';
export const UPGRADE = 'UPGRADE';
export const INVALID_CARD = 'INVALID_CARD';
export const ABSENT_CARD = 'ABSENT_CARD';
export const CANNOT_ADD_SPEAKER = 'CANNOT_ADD_SPEAKER';
export const CANNOT_ADD_EXHIBITOR = 'CANNOT_ADD_EXHIBITOR';
// METERED PRICING MODAL TYPES
export const meterModalConfig = {
    [ALLOW_EXTRA_REGISTRANTS]: {
        header: 'Pay as you go billing',
        subHeader: 'per additional registration',
    },
    [ADD_EXTRA_REGISTRANTS]: {
        header: 'Add extra registrations',
        subHeader:
            'You can add extra registrations to the yearly quota by talking to our sales team. ',
        externalActionUrl: 'https://airmeet.typeform.com/to/NfzPPDdq', // replace url with typeform url
    },
    [ABSENT_CARD]: {
        header: 'Enable pay as you go billing',
        subHeader: ' Contact our sales to activate this to your account.',
        externalActionUrl: 'https://airmeet.typeform.com/to/NfzPPDdq', // replace url with typeform url
    },
    [UPGRADE]: {
        header: 'Upgrade to enable pay as you go billing',
        subHeader: ' beyond your plan limits by upgrading your current plan',
    },
    [INVALID_CARD]: {
        header: 'Invalid Card Details',
        subHeader:
            'Looks like the card details provided are incorrect/invalid. Please contact support to add new card details and activate extra registrations',
        externalActionUrl: 'https://airmeet.typeform.com/to/NfzPPDdq', // replace url with typeform url
    },
    [CANNOT_ADD_SPEAKER]: {
        header: 'Cannot add speakers',
        subHeader: '',
        textOne:
            'You cannot add more speakers since you have reached your registrations limit.',
        textTwo: 'To add a new speaker, please allow extra registrations.',
        contactSalesText:
            'To add a new speaker, please contact our sales team to enable extra registrations.',
        freePlanText:
            'To add a new speaker, please allow extra registrations by upgrading to a premium plan.',
    },
    [CANNOT_ADD_EXHIBITOR]: {
        header: 'Cannot add exhibitors',
        subHeader: '',
        textOne:
            'You cannot add more exhibitors since you have reached your registrations limit.',
        textTwo: 'To add a new exhibitor, please allow extra registrations. ',
        contactSalesText:
            'To add a new exhibitor, please contact our sales team to enable extra registrations. ',
        freePlanText:
            'To add a new exhibitor, please allow extra registrations by upgrading to a premium plan.',
    },
};
